import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ResearchAuthService } from './auth.service';

@Injectable()
export class ResearchAuthGuard implements CanActivate {
    public static loginRoute = '/login';

    constructor(private router: Router, private authService: ResearchAuthService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.authService.deepLinkRoute(state.url);

        if (state.url !== `${ResearchAuthGuard.loginRoute}`) {
            const claimsExist = this.authService.userClaimsExist();

            if (!claimsExist) {
                this.router.navigate([`${ResearchAuthGuard.loginRoute}`]);
                return false;
            }
        }

        return true;
    }
}
